import posthog from 'posthog-js';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { useAppDispatch } from 'redux/store';
import {
  getUserEmail,
  getUserId,
  getUserIsIdentified,
  getUserPlanTier,
  getUserRole,
  getUserSubscriptionStatus,
  setUserIsIdentified,
} from 'redux/user';

const isPostHogEnv = import.meta.env.REACT_APP_DEPLOY_ENV !== 'dev';

export default function usePostHog() {
  const location = useLocation();

  const dispatch = useAppDispatch();
  const id = useSelector(getUserId);
  const email = useSelector(getUserEmail);
  const role = useSelector(getUserRole);
  const planTier = useSelector(getUserPlanTier);
  const subscriptionStatus = useSelector(getUserSubscriptionStatus);
  const isIdentified = useSelector(getUserIsIdentified);

  useEffect(() => {
    if (id && role && isPostHogEnv) {
      posthog.init(import.meta.env.REACT_APP_POST_HOG_KEY, {
        api_host: 'https://e.syllabird.com',
        flags_api_host: 'https://f.syllabird.com',
        ui_host: 'https://us.posthog.com',
        autocapture: true,
        session_recording: {
          maskAllInputs: false,
          maskInputOptions: { password: true },
        },
        loaded: (posthog) => {
          posthog.identify(id, {
            ...(email && { email }),
            role,
          });
          dispatch(setUserIsIdentified(true));
        },
      });
    }
  }, [id, email, role, dispatch]);

  useEffect(() => {
    if (planTier && subscriptionStatus && isIdentified && isPostHogEnv) {
      posthog.setPersonProperties({ planTier, subscriptionStatus });
    }
  }, [planTier, subscriptionStatus, isIdentified]);

  useEffect(() => {
    isPostHogEnv && posthog.capture('$pageview');
  }, [location]);
}
